import React, { useState } from "react";
import { Menu, Drawer, Button, Image, Divider } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import "../Styles/IcaseHeaderStyles.css";
import logo from "../Assets/logoicast.svg";
import supcarco from "../Assets/suparco.png";
import ist from "../Assets/ist-logo.png";
import { Link, useLocation } from "react-router-dom";

const { SubMenu } = Menu;

const LogoSection = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [openKeys, setOpenKeys] = useState([]); // controls SubMenu open state
  const location = useLocation();

  const showDrawer = () => setDrawerVisible(true);
  const closeDrawer = () => setDrawerVisible(false);

  // Keep only one submenu open at a time (optional, looks cleaner on mobile)
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((k) => !openKeys.includes(k));
    if (!latestOpenKey) {
      setOpenKeys([]);
    } else {
      setOpenKeys([latestOpenKey]);
    }
  };

  const menuItemStyle = {
    backgroundColor: "white",
    marginBottom: "10px",
    padding: "10px 20px",
  };

  const subMenuStyle = {
    backgroundColor: "white",
    marginBottom: "10px",
  };

  const subMenuTitleStyle = { color: "black" };

  return (
    <>
      <header className="header-container">
        <div className="left-section">
          <Link to={"/"}>
            <img src={logo} alt="ICAST Logo" className="main-logo" />
          </Link>

          <div className="header-text">
            <h1>
              INTERNATIONAL CONFERENCE ON APPLICATIONS OF SPACE SCIENCE &amp;
              TECHNOLOGY
            </h1>
            <h2>"Space for Sustainable Development"</h2>
            <h3>Institute of Space Technology, Islamabad, Pakistan</h3>
            <button className="date-button">November 18-20, 2025</button>
          </div>
        </div>

        <div className="right-section">
          <div className="partners-background">
            <a
              href="https://suparco.gov.pk/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                preview={false}
                src={supcarco}
                alt="SUPARCO Logo"
                className="partner-logo"
              />
            </a>

            <a
              href="https://ist.edu.pk/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                preview={false}
                src={ist}
                alt="IST Logo"
                className="partner-logo"
              />
            </a>
          </div>

          <Button
            type="text"
            icon={<MenuOutlined />}
            className="mobile-menu-icon"
            onClick={showDrawer}
          />
        </div>

        {/* Mobile Drawer Menu */}
        <Drawer
          title={<span style={{ color: "white" }}>ICAST Menu</span>}
          placement="right"
          onClose={closeDrawer}
          open={drawerVisible} // ✅ AntD v5
          style={{
            backgroundColor: "#1E2634",
            overflow: "hidden",
          }}
          bodyStyle={{
            padding: 0,
            margin: 0,
            overflowY: "auto",
          }}
          closeIcon={
            <span style={{ color: "white", fontSize: "16px" }}>✖</span>
          }
        >
          <Menu
            style={{
              backgroundColor: "#1E2634",
              borderRight: "none",
              padding: "20px",
            }}
            mode="inline"
            selectedKeys={[location.pathname]} // ✅ highlights active page
            openKeys={openKeys}
            onOpenChange={onOpenChange}
          >
            {/* ✅ ABOUT ICAST (now contains Call for Content items too) */}
            <SubMenu
              key="about-icast"
              title={<span style={subMenuTitleStyle}>About ICAST</span>}
              style={subMenuStyle}
            >
              <Menu.Item key="/" style={menuItemStyle}>
                <Link to="/" onClick={closeDrawer}>
                  About ICAST
                </Link>
              </Menu.Item>

              <Menu.Item key="/genisis" style={menuItemStyle}>
                <Link to="/genisis" onClick={closeDrawer}>
                  Genesis
                </Link>
              </Menu.Item>

              <Menu.Item key="/icast-2025" style={menuItemStyle}>
                <Link to="/icast-2025" onClick={closeDrawer}>
                  ICAST 2025
                </Link>
              </Menu.Item>

              <Menu.Item key="/tracks" style={menuItemStyle}>
                <Link to="/tracks" onClick={closeDrawer}>
                  Theme &amp; Tracks
                </Link>
              </Menu.Item>

              <Menu.Item key="/governance" style={menuItemStyle}>
                <Link to="/governance" onClick={closeDrawer}>
                  Governance Structure
                </Link>
              </Menu.Item>

            <Menu.Item key="/content" style={menuItemStyle}>
                <Link to="/content" onClick={closeDrawer}>
                  Call For Content
                </Link>
              </Menu.Item>

              {/* ✅ Call for Content items moved here */}
              <Menu.Item key="/call-for-papers" style={menuItemStyle}>
                <Link to="/call-for-papers" onClick={closeDrawer}>
                  Call For Papers
                </Link>
              </Menu.Item>

              <Menu.Item key="/call-for-session" style={menuItemStyle}>
                <Link to="/call-for-session" onClick={closeDrawer}>
                  Call For Sessions
                </Link>
              </Menu.Item>

              <Menu.Item key="/author-resources" style={menuItemStyle}>
                <Link to="/author-resources" onClick={closeDrawer}>
                  Author Resources
                </Link>
              </Menu.Item>

              <Menu.Item key="/registration" style={menuItemStyle}>
                <Link to="/registration" onClick={closeDrawer}>
                  Registration
                </Link>
              </Menu.Item>
            </SubMenu>

            {/* Other Menu Items */}
            <Menu.Item key="/expo" style={menuItemStyle}>
              <Link to="/expo" onClick={closeDrawer}>
                Exposition &amp; Sponsors
              </Link>
            </Menu.Item>

            <Menu.Item key="/conference-program" style={menuItemStyle}>
              <Link to="/conference-program" onClick={closeDrawer}>
                Conference Program
              </Link>
            </Menu.Item>

            <Menu.Item key="/icast-delegates" style={menuItemStyle}>
              <Link to="/icast-delegates" onClick={closeDrawer}>
                ICAST Delegates
              </Link>
            </Menu.Item>

            <Menu.Item key="/press-release" style={menuItemStyle}>
              <Link to="/press-release" onClick={closeDrawer}>
                Media Release
              </Link>
            </Menu.Item>
          </Menu>
        </Drawer>
      </header>
    </>
  );
};

export default LogoSection;
